

import HzYuqing from './sentiment/index.vue'


const customChart = {
  HzYuqing

}
const install = function(Vue, opts = {}) {
  Vue.component("HzYuqing",HzYuqing)
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default Object.assign(customChart, { install });



// WEBPACK FOOTER //
// ./src/components/index.js